import { j as o } from "../../../../../../jsx-runtime.BREq8dyb.js";
import { Alert as r } from "@mui/joy";
import { memo as a } from "react";
import { S as t } from "../../../../../../index.B-E4PB3F.js";
const s = a(({
  syncDirection: e
}) => /* @__PURE__ */ o.jsx(r, { children: e === t.IMPORT ? "This will import Publisher datasets from PermutiveInfo via a Cloud Storage service and store them as datasets in the Decentriq platform. These datasets can then be provisioned directly to Decentriq datalabs for Publishers." : e === t.EXPORT ? "This will export the selected dataset directly as an imported segment on PermutiveInfo using a Cloud Storage service. The dataset should have only one column with PermutiveInfo IDs, and the segment will be added automatically to them. Note: Please access your PermutiveInfo account to verify the imported segment." : null }));
s.displayName = "PermutiveInfo";
export {
  s as default
};
//# sourceMappingURL=PermutiveInfo.js.map
